import * as React from "react";
import type { SVGProps } from "react";
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.color}
      d="M7.58 6.52a.75.75 0 0 0-1.06 1.06L10.94 12l-4.42 4.42a.75.75 0 1 0 1.06 1.06L12 13.06l4.42 4.42a.75.75 0 1 0 1.06-1.06L13.06 12l4.42-4.42a.75.75 0 0 0-1.06-1.06L12 10.94z"
    />
  </svg>
);
export default Icon;
